module.exports = __webpack_public_path__ + "img/pic_word.d9ec1641.png";